import { render, staticRenderFns } from "./ModalAssetDetails.vue?vue&type=template&id=b4a67e44"
import script from "./ModalAssetDetails.vue?vue&type=script&lang=js"
export * from "./ModalAssetDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports